import { useState } from "react";

import { Dialog } from "@mui/material";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

import { FrmTextField } from "components/formFields/FrmTextField";
import { Link } from "components/html/Link";
import { FormErrors } from "components/utility/FormErrors";
import { VSpace } from "components/utility/VSpace";

import { i18n } from "services/i18nService";
import { isValid } from "services/sosInventoryService/upsAccount/isValid";

import { useErrors } from "hooks/useErrors";

import { UpsTrademark } from "views/UpsShipments/UpsShipment/UpsTrademark";

import { UPS_AUTH_REDIRECT_URL } from "appConstants";

export function AddAccountDialog(props) {
  const { open, handleClose } = props;

  const [record, setRecord] = useState({ number: null, description: null });
  const { errors, setErrors, isInError } = useErrors();

  function handleInputFieldChange(fieldName, value) {
    setRecord((prevRecord) => ({ ...prevRecord, [fieldName]: value }));
  }

  function startUpsAuthFlow() {
    const errors = isValid(record);
    if (errors.messages.length > 0) {
      setErrors(errors);
      return;
    }

    const state = btoa(`${record.number}|${record.description || ""}`);
    localStorage.setItem("upsState", state);
    const clientId = process.env.REACT_APP_UPS_CLIENT_ID;
    window.location.href = `https://onlinetools.ups.com/security/v1/oauth/authorize?client_id=${clientId}&redirect_uri=${UPS_AUTH_REDIRECT_URL}&response_type=code&state=${state}`;
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ inset: "0 0 10%" }}
    >
      <DialogTitle>{i18n("upsAccount.EnterInfo")}</DialogTitle>
      <DialogContent>
        <FormErrors errors={errors} setErrors={setErrors} />

        <VSpace space={1} />
        <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
          <div style={{ width: "12rem" }}>
            <FrmTextField
              name="number"
              label={i18n("frmLabel.UpsAccountNumber")}
              onValueBlur={handleInputFieldChange}
              value={record.number}
              error={isInError("number")}
            />
          </div>
          <div style={{ alignItems: "center" }}>
            <Link
              component="a"
              rel="noreferrer"
              href="https://www.ups.com/account/us/start?loc=en_US"
              target="_blank"
            >
              {i18n("upsAccount.NeedAUpsAccount")}
            </Link>
          </div>
        </Box>
        <FrmTextField
          name="description"
          label={i18n("frmLabel.AccountDescription")}
          onValueBlur={handleInputFieldChange}
          value={record.description}
        />
        <VSpace space={1} />
        <Typography>
          {i18n("upsAccount.FindYourAccountNumber.1")}{" "}
          <Link
            component="a"
            rel="noreferrer"
            href="https://www.ups.com/"
            target="_blank"
          >
            www.ups.com
          </Link>
          {i18n("upsAccount.FindYourAccountNumber.2")}
        </Typography>
        <UpsTrademark />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose}>
          {i18n("button.Cancel")}
        </Button>
        <div style={{ position: "relative" }}>
          <Button color="secondary" onClick={startUpsAuthFlow}>
            {i18n("upsAccount.ConnectToUps")}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}
